import React, { useState, useEffect } from 'react';

import './styles.css';

import studentsServices from '../../../services/academy/studentsServices';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';

import StudentProfileCard from '../../academyPages/Student/StudentProfileCard'
import StudentClassCard from '../../academyPages/Student/StudentClassCard'
import ClassTrainingsCard from '../../academyPages/Class/ClassTrainingsCard'
import StudentDocumentsCard from '../../academyPages/Student/StudentDocumentsCard'

import ClassCallListsCard from '../../academyPages/Class/ClassCallListsCard'
import StudentPaymentsCard from '../../academyPages/Student/StudentPaymentsCard'

import ActivityIndicator from '../../../components/ActivityIndicator';

export default function StudentProfile() {
    const [studentInfos, setStudentInfos] = useState({});
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        readStudentInfos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function readStudentInfos() {
        const id = localStorage.getItem("_id");
        const response = await studentsServices.getStudentInfos(id);
        setFetching(false);
        if (response.status === 200) {
            setStudentInfos(response.data);
        } else
            alert("Erro ao ler informações de aluno, tente novamente!");
    };

    return (
        <MainView currentPage='profile' studentMenu>
            <NavHistory navPages={['Meu perfil']} />
            {
                !fetching ?
                    <div className='student-profile-page-cards'>
                        <div className='student-profile-page-cards-group'>
                            <StudentProfileCard studentProfileMode studentInfos={studentInfos} />
                            <StudentClassCard studentProfileMode studentInfos={studentInfos} studentId={studentInfos.id} />
                            {studentInfos.turma !== null ?
                                <ClassTrainingsCard studentProfileMode classId={studentInfos.turma ? studentInfos.turma.id : null} />
                                :
                                null
                            }
                            <StudentDocumentsCard studentProfileMode studentId={studentInfos.id} />
                        </div>
                        <div className='student-profile-page-cards-group'>
                            {studentInfos.turma !== null ?
                                <ClassCallListsCard studentProfileMode classId={studentInfos.turma ? studentInfos.turma.id : null} />
                                :
                                null
                            }
                            <StudentPaymentsCard paid studentProfileMode studentId={studentInfos.id} />
                        </div>
                    </div>
                    : <ActivityIndicator />
            }
        </MainView>
    )
}